import React from "react";
import Select from "react-select";

const SearchableSelect = ({
  id, name, value, onChange, onBlur, disabled, isInvalid,
  options = [],
  placeholder = "เลือก...",
  noOptionsMessage,
}) => {
  const selectedOption =
    options.find((opt) => String(opt.value) === String(value)) || null;

  const handleChange = (option) => {
    onChange?.({ target: { name, value: option ? option.value : "" } });
  };

  const handleBlur = () => {
    onBlur?.({ target: { name } });
  };

  return (
    <Select
      inputId={id}
      name={name}
      value={selectedOption}
      onChange={handleChange}
      onBlur={handleBlur}
      isDisabled={disabled}
      options={options}
      placeholder={placeholder}
      isClearable
      isSearchable
      classNamePrefix="rs"
      className={isInvalid ? "rs--invalid" : ""}
      menuPortalTarget={document.body}
      noOptionsMessage={() => noOptionsMessage || "ไม่พบข้อมูล"}
    />
  );
};

export default SearchableSelect;